import React from 'react';
import NotFoundPage from './404page';
import llama_magnify_clay from '../../assets/images/bumpclay/llama-magnify-clay.png';

const NotFoundWorkspace = () => (
  <NotFoundPage
    heading1="Lost?"
    heading2="This workspace isn't available. Sorry about that."
    paragraph="Head back to Workspace to start a new one."
    image={llama_magnify_clay}
    buttonText="Go to Workspace"
    buttonLink="/workspace"
  />
);

export default NotFoundWorkspace;
